module.exports = __webpack_public_path__ + "img/2018-10-26.0a22e3a7.jpg";